import {createSlice} from '@reduxjs/toolkit';

interface IMerchantTopup {
  seedflexMId: string | number;
  id: string | number;
  name: string;
  merchantName: string;
  merchantBusinessName: string;
  partnerName: string;
  partnerIdentifier: string | number;
  currency: string;
  smeMaskedId: string | number;
  mpId: string | number;
}

interface IAdvanceData {
  finalTopupLimit: number;
  topupLimitStatus: string;
  initialLoanId: number;
}

interface IOverrideTopup {
  expectedMaxTenure: number;
  maxTopUpLimit: number;
  reason: string;
}

export interface ITopupPreviewData {
  maxTopupLimit: number;
  tentativeMaxTenure: number;
  seedflexMId: string | number;
  businessName: string;
  initialLoanId: number;
  currency: string;
  topupLimitStatus: string;
  expectedMaxTenure: number;
}

interface ITopupLimit {
  input: 'businessName' | 'seedflexMId';
  advanceData: IAdvanceData | null;
  merchantTopup: IMerchantTopup | null;
  overrideTopup: IOverrideTopup | null;
  topupPreviewData: ITopupPreviewData | null;
}

const initialState: ITopupLimit = {
  input: 'businessName',
  advanceData: null,
  merchantTopup: null,
  overrideTopup: null,
  topupPreviewData: null,
};

const topupLimit = createSlice({
  name: 'topupLimit',
  initialState,
  reducers: {
    setInput(state, actions) {
      state.input = actions.payload;
    },
    setAdvanceData(state, actions) {
      state.advanceData = actions.payload;
    },
    setMerchantTopup(state, actions) {
      state.merchantTopup = actions.payload;
    },
    setOverrideTopup(state, actions) {
      state.overrideTopup = actions.payload;
    },
    setTopupPreviewData(state, actions) {
      state.topupPreviewData = actions.payload;
    },
    resetState() {
      return initialState;
    },
  },
});

const topupLimitReducer = topupLimit.reducer;

export const topupLimitActions = topupLimit.actions;

export default topupLimitReducer;
